// src/lib/validation.js
// Validaciones puras (sin side-effects) — fáciles de testear.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function isValidEmail(email) {
  if (typeof email !== 'string') return false
  const trimmed = email.trim()
  return trimmed.length >= 5 && trimmed.length <= 254 && EMAIL_RE.test(trimmed)
}

export function isValidPhoneMx(phone) {
  if (typeof phone !== 'string') return false
  const digits = phone.replace(/\D/g, '')
  return digits.length === 10
}

export function isValidUUID(value) {
  return typeof value === 'string' && UUID_RE.test(value)
}

export function passwordStrength(password) {
  if (typeof password !== 'string') return { ok: false, reason: 'Contraseña inválida' }
  if (password.length < 8) return { ok: false, reason: 'Mínimo 8 caracteres' }
  const hasLetter = /[a-zA-Z]/.test(password)
  const hasNumber = /[0-9]/.test(password)
  if (!hasLetter || !hasNumber) {
    return { ok: false, reason: 'Debe incluir letras y números' }
  }
  return { ok: true }
}

export function isValidPriceMxn(value) {
  const n = Number(value)
  if (!isFinite(n) || isNaN(n)) return false
  return n >= 350 && n <= 99999
}

export function freeLeadsRemaining(used, limit = 5) {
  const u = Number.isFinite(used) ? Math.max(0, used) : 0
  return Math.max(0, limit - u)
}

// Anti-bot client-side: limita N intentos en una ventana de tiempo en localStorage.
// Devuelve true si está permitido, false si está rate-limited.
export function checkClientRateLimit(key, maxAttempts, windowMs, now = Date.now(), storage) {
  const store = storage || (typeof localStorage !== 'undefined' ? localStorage : null)
  if (!store) return true
  let raw
  try { raw = JSON.parse(store.getItem(key) || '[]') } catch { raw = [] }
  const cutoff = now - windowMs
  const arr = (Array.isArray(raw) ? raw : []).filter((t) => t > cutoff)
  if (arr.length >= maxAttempts) return false
  arr.push(now)
  try { store.setItem(key, JSON.stringify(arr)) } catch {
    // localStorage puede estar lleno o bloqueado en modo privado — no es crítico.
  }
  return true
}
